import { render } from "./CropMineralFertilizationForm.vue?vue&type=template&id=6493d05a&scoped=true&ts=true"
import script from "./CropMineralFertilizationForm.vue?vue&type=script&lang=ts"
export * from "./CropMineralFertilizationForm.vue?vue&type=script&lang=ts"

import "./CropMineralFertilizationForm.vue?vue&type=style&index=0&id=6493d05a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6493d05a"]])

export default __exports__